'use client'

import React from 'react'

import type { Header as HeaderType } from '@/payload-types'

import { CMSLink } from '@/components/Link'

interface HeaderNavProps {
  data: HeaderType
  mobile?: boolean
  onMenuItemHover?: (index: number | null, immediate?: boolean) => void
}

export const HeaderNav: React.FC<HeaderNavProps> = ({ data, mobile = false, onMenuItemHover }) => {
  const navItems = data?.navItems || []

  if (mobile) {
    return (
      <ul id="topNavMobile" className="d-flex flex-column m-0 p-0">
        {navItems.map(({ link }, i) => (
          <li key={i} className="nav-item">
            <CMSLink {...link} className="text-dark" />
          </li>
        ))}
      </ul>
    )
  }

  return (
    <ul id="topNavDesk" className="p-0 flexCS m-0">
      {navItems.map(({ link, hasMegaMenu, color }, i) => (
        <li
          key={i}
          className="nav-item ms-1"
          onMouseEnter={() => onMenuItemHover?.(hasMegaMenu ? i : null)}
        >
          <CMSLink {...link} className="nav-link" />
          {hasMegaMenu && (
            <i className={`icon icon-chevron-down-1 ms-2 text-${color || 'white'}`}></i>
          )}
        </li>
      ))}
    </ul>
  )
}
